import type { AbstractControl } from '@angular/forms';

export class FormUtils {
  static getControl(form: AbstractControl, control: Parameters<AbstractControl['get']>[0]): AbstractControl | null {
    return form?.get(control) ?? null;
  }
}
